import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { getFeatureSwitches } from '@/api/featureSwitches/getFeatureSwitches';
import { Feature } from '@/@types/featureSwitch';

export const useGetFeatureSwitches = () => {
  const { isLoading, isFetching, data, isError } = useQuery({
    queryKey: ['feature-switches'],
    queryFn: getFeatureSwitches,
  });

  return {
    initializing: isLoading || isFetching || isError,
    features: data?.features,
  };
};

export const useFeature = (feature: Feature): boolean => {
  const { initializing, features } = useGetFeatureSwitches();

  const featureMap = useMemo(() => {
    if (initializing || !features) return {};
    return Object.fromEntries(features.map((f) => [f.feature, f.enabled]));
  }, [initializing, features]);

  return !!featureMap[feature];
};
